// extracted by mini-css-extract-plugin
export default {"trigger":"ExpandableSection__trigger___JzjQp","root":"ExpandableSection__root___amVfG","icon":"ExpandableSection__icon___GSc9L"};